var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconWarning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "25px",
    viewBox: "0 0 29 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "6.72231812%",
    y1: "78.7099462%",
    x2: "98.2235491%",
    y2: "21.8355504%",
    id: "linearGradient-6a0-11uzg4-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F0F10",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313131",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Moneygram12",
    transform: "translate(-495.000000, -447.000000)",
    fill: "url(#linearGradient-6a0-11uzg4-1)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Nationality",
    transform: "translate(475.000000, 428.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.420276,37.8028489 L38.2603551,21.0728109 C36.6008615,18.309063 32.4043725,18.309063 30.7508483,21.0728109 L20.584958,37.8028489 C18.9254645,40.5665967 20.9908773,44 24.3397114,44 L44.6297062,44 C47.9785403,44 50.0797696,40.5325464 48.420276,37.8028489 Z M34.5172135,40 C33.627944,40 32.8888889,39.3191882 32.8888889,38.5 C32.8888889,37.6808118 33.627944,37 34.5172135,37 C35.406483,37 36.145538,37.6808118 36.1094866,38.5387454 C36.1515466,39.3191882 35.3704315,40 34.5172135,40 Z M35.9646465,30.0829597 C35.8943434,31.2976014 35.8181818,32.5064591 35.7478788,33.7211008 C35.7127273,34.1144134 35.7127273,34.4730219 35.7127273,34.8605504 C35.6775758,35.5025753 35.1678788,36 34.5175758,36 C33.8672727,36 33.3634343,35.5372794 33.3224242,34.8952545 C33.2169697,33.0038838 33.1056566,31.1472172 33.000202,29.2558466 C32.9650505,28.7584219 32.929899,28.2552132 32.8888889,27.7577885 C32.8888889,26.9364593 33.3575758,26.2597304 34.1191919,26.0457221 C34.8808081,25.8664178 35.6365657,26.2250263 35.9646465,26.9364593 C36.0759596,27.1851717 36.1111111,27.433884 36.1111111,27.7230844 C36.0759596,28.5154935 35.999798,29.3021186 35.9646465,30.0829597 Z",
    id: "Shape"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarning);
export default __webpack_public_path__ + "static/media/icon-warning.5b3598eadc039b992bf7b7c2ef6082e6.svg";
export { ForwardRef as ReactComponent };